<template>
  <!--BOOST LANDING PAGE: Story CD-18 -->
  <div class="flex items-center justify-center bg-white px-4">
    <div class="w-full max-w-md text-center">
      <h2 class="text-[22px] font-semibold text-grey-light-400">{{ title }}</h2>

      <p class="mt-2 text-[14px] text-grey-light-400">{{ description }}</p>

      <div class="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center sm:gap-4">
        <Button
          variant="outline"
          @click="emit('click')"
          class="w-full text-[14px] justify-center text-grey-light-400 transition hover:bg-brand-50 hover:border-brand-300 hover:text-brand-800 sm:w-auto h-[40px]"
        >
          <Plus />
          {{ buttonText }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-vue-next';

defineProps<{
  title?: string;
  description?: string;
  buttonText?: string;
}>();

const emit = defineEmits(['click']);
</script>
